import React, { Component } from 'react';
import Util from '../../util.js';
import NavigatorMain from '../NavigatorMain';
import { hashHistory } from 'react-router';
/*配置详情*/
class Configuration extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    document.getElementsByTagName('title')[0].innerHTML = "配置明细";
  }
  goBack(){
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
            
  render() {
    let data = this.props.location.state.data ? this.props.location.state.data : [];
    // data = data.sort(compare('rateInGroup'))
    // for(let k=0; k<data.length; k++){
    //   if(data[k].rateInGroup <= 0.01){
    //     data.splice(k,1)
    //   }
    // }
    return (
        <div className="container">
          <NavigatorMain>
          <div className="header black">
            <div ><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div >配置明细</div>
            <div ></div>    
          </div>
          </NavigatorMain>
          <div className='content'>
          {
            data.map((item,i)=>{
              return(
                <div className="superListJ superConfiguration" key = {i} >
                  <div style={{ borderBottom:'1px solid #f2f4f7'}}>
                    <span style={{ color:'#fa063a'}}>{ item.fundName }</span>
                    <span style={{ color:'#fa063a'}}>
                      {
                        item.rateInGroup != null ? Util.fomatFloat(item.rateInGroup * 100) + "%" : "--"
                      }
                    </span>
                  </div>
                  <div>
                    <span>
                      {
                        "资产金额:" +(item.balance != null ? Util.fomatFloat(item.balance) + "元" : "--" )
                      }
                    </span>
                    <span>
                      {
                        "可用份额:" +  (item.availableVolume != null ? Util.fomatFloat(item.availableVolume) + "份" : "--")
                      }
                    </span>
                  </div>
                </div>
              )
            })
          }
          </div>
        </div>
    );
  }
}

function compare(prop){
    // return function(a,b){
    //     var allStartDate = getDateS(a[property]);   
    //     var allEndDate = getDateS(b[property]);
    //     var value1 = allStartDate.getTime()
    //     var value2 = allEndDate.getTime()
    //     return value2 - value1;
    // }
    return function (obj1, obj2) {
      var val1 = obj1[prop];
      var val2 = obj2[prop];
      if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
      }
      if (val1 > val2) {
          return -1;
      } else if (val1 < val2) {
          return 1;
      } else {
          return 0;
      }            
    }
}

export default Configuration;



// WEBPACK FOOTER //
// ./src/components/fundDetail/Configuration.js